import { Avatar, AvatarFallback } from "@/components/ui/avatar"
import { cn } from "@/lib/utils"

const avatarColors = [
  "bg-blue-500 text-white",
  "bg-green-500 text-white",
  "bg-purple-500 text-white",
  "bg-orange-500 text-white",
  "bg-pink-500 text-white",
  "bg-teal-500 text-white",
  "bg-indigo-500 text-white",
  "bg-red-500 text-white",
]

export function getInitials(firstName: string, lastName: string) {
  return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
}

export function getColorClass(firstName: string, lastName: string) {
  const str = `${firstName}${lastName}`
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  return avatarColors[Math.abs(hash) % avatarColors.length]
}

type Props = {
  user: { first_name: string; last_name: string; email_address?: string }
  size?: "sm" | "default" | "lg"
  showEmail?: boolean
  avatarOnly?: boolean
  className?: string
}

export function UserDisplay({ user, size = "default", showEmail = false, avatarOnly = false, className }: Props) {
  const initials = getInitials(user.first_name, user.last_name)
  const colorClass = getColorClass(user.first_name, user.last_name)

  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <Avatar size={size}>
        <AvatarFallback className={colorClass}>{initials}</AvatarFallback>
      </Avatar>
      {!avatarOnly && (
        <span className="flex flex-col">
          <span className="text-sm font-medium leading-tight">
            {user.first_name} {user.last_name}
          </span>
          {showEmail && user.email_address && (
            <span className="text-xs text-muted-foreground leading-tight">{user.email_address}</span>
          )}
        </span>
      )}
    </span>
  )
}
